import {
    BASIC_LOT_DETAILS,
    PICKUP_ADDRESS,
    PICKUP_DETAILS,
    PICKUP_SCHEDULE_DETAILS,
    TITLE_DETAILS
} from '../constants';
import basicLotFields from './basicLotDetails';
import pickupAddressFields from './pickupAddress';
import pickupDetailsFields from './pickupDetails';
import pickupScheduleDetailsFields from './pickupScheduleDetails';
import titleFields from './titleDetails';
  
export default {
    [BASIC_LOT_DETAILS]: basicLotFields,
    [PICKUP_ADDRESS]: pickupAddressFields,
    [PICKUP_DETAILS]: pickupDetailsFields,
    [TITLE_DETAILS]: titleFields
};



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/index.js